import React, {Fragment} from "react";
import {useAuth0} from "../../react-auth0-spa";
import TopBar from "../TopBar";
import Navbar from "../Navbar";
import ContactUs from "../ContactUs";
import Footer from "../Footer";
import Project from "../Project";
import Description from "../Description";
import AboutUs from "../AboutUs";
import Ktsm from "../KTSM";
import Business from "../Business";

const HomePage = () => {
    const {isAuthenticated, loginWithRedirect, logout} = useAuth0();
    return (
        <Fragment>
            <TopBar></TopBar>
            <Navbar></Navbar>
            <AboutUs></AboutUs>
            <Business></Business>
            <Ktsm></Ktsm>
            {/*<Description></Description>*/}
            <Footer></Footer>
        </Fragment>
    )
}

export default HomePage;